import axios from 'axios'

const aquaApi = axios.create({
  baseURL: '',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

const setApiAuthHeader = (token: string): void => {
  aquaApi.defaults.headers.common.Authorization = `Bearer ${token}`
}

const removeApiAuthHeader = (): void => {
  delete aquaApi.defaults.headers.common.Authorization
}

const updateApiBaseUrl = (baseUrl: string): void => {
  aquaApi.defaults.baseURL = baseUrl
  console.log('AquaApi baseURL configurada:', baseUrl)
}

export { aquaApi, setApiAuthHeader, removeApiAuthHeader, updateApiBaseUrl }
